
function compileTemplateFromText (sourceText: string, stripWhitespace?: boolean): Handlebars.TemplateDelegate {
	let source = sourceText.replace(/%7D/g, '}').replace(/%7B/g, '{');

	if (stripWhitespace) {
		// adapted from https://stackoverflow.com/questions/12014441/remove-every-white-space-between-tags-using-javascript
		source = source.replace(/(<(pre|script|style)[^]+?<\/\2)|(^|>)\s+|\s+(?=<|$)/g, '$1$3');
	}
	return Handlebars.compile(source);
}

function compileTemplateFrom (id: string, stripWhitespace?: boolean): Handlebars.TemplateDelegate {
	return compileTemplateFromText(document.getElementById(id)!.innerHTML, stripWhitespace);
}

export default {
	compileTemplateFrom,
	compileTemplateFromText
};
